import { render, staticRenderFns } from "./modal-notification-detail.vue?vue&type=template&id=19a25632&scoped=true&"
import script from "./modal-notification-detail.vue?vue&type=script&lang=js&"
export * from "./modal-notification-detail.vue?vue&type=script&lang=js&"
import style0 from "./modal-notification-detail.vue?vue&type=style&index=0&id=19a25632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a25632",
  null
  
)

export default component.exports